/* ------------------------------------------------------------------------
			COMPARE AND QUICKVIEW FUNCTION STARTS
			--------------------------------------------------------------------------*/

var countno = 0; // Defining Global Variable

function compareAndQuickView() {

    window.show_light_box = function() {
        /* Scene7 code */
        window.open_scene7_overlay = function(obj) {
            var s7spin_container = $('#s7spin_container');
            s7enlarge_container = $('#s7enlarge_container');
            wcs_enlarge = $('.wcs-scene7-toggle .wcs-enlarge');
            if (wcs_enlarge.length) {
                wcs_enlarge.data('selected', (obj).data('selected'));
            }

            if ($(obj).hasClass('wcs-360-compare')) {

                var wcs_product_compare_lightbox = $(".wcs-Product-compare-lightbox");
                var wcs_compare_view = wcs_product_compare_lightbox.find("#wcs-compare-view");
                var wcs_compare_bottom_bar = wcs_product_compare_lightbox.find(".wcs-compare-bottom-bar");
                var wcs_enlarge_rotate_mid = $("#wcs_enlarge_rotate_mid").clone(true).hide().removeClass("wcs-hidden").attr("id", "wcs_enlarge_rotate_mid_compare");

                $(wcs_enlarge_rotate_mid).find(".wcs-scene7-title strong").html($(obj).data("productdescription"));
                $(wcs_enlarge_rotate_mid).find("#wcs-rotate-enlarge-skuValue").html($(obj).data("sku"));
                $(wcs_enlarge_rotate_mid).find(".wcs-scene7-toggle .wcs-back").show();

                $(wcs_compare_view).fadeOut("slow", function() {
                    $(wcs_product_compare_lightbox).append(wcs_enlarge_rotate_mid);
                    $(wcs_enlarge_rotate_mid).fadeIn("fast", function() {
                        window.initS7Rotate("wcs_enlarge_rotate_mid_compare", "935,824", $(obj).data("s7imgspin"));
                    });
                });

                $(wcs_compare_bottom_bar).fadeOut("slow");

                $(wcs_enlarge_rotate_mid).find(".wcs-scene7-toggle .wcs-back a").off("click").on("click", function(e) {

                    $(wcs_enlarge_rotate_mid).fadeOut("slow", function() {
                        $(wcs_compare_view).fadeIn("fast", function() {
                            $(wcs_enlarge_rotate_mid).remove();
                        });
                        $(wcs_compare_bottom_bar).fadeIn("fast");
                    });

                    e.preventDefault();
                });
            } else if ($(obj).hasClass('wcs-360-degree') || $(obj).hasClass('wcs-spin')) {
                $(".wcs-scene7-toggle .wcs-enlarge").show();
                $(".wcs-scene7-toggle #wcs_enlarge_pipe").show();
                $(".wcs-scene7-toggle .wcs-spin.wcs-spin-label").show();

                s7spin_container.show();
                s7enlarge_container.hide();

                $('.wcs-scene7-toggle span').removeClass('wcs-color0');
                $('.wcs-scene7-toggle span.wcs-spin').addClass('wcs-color0');
                $('.wcs-scene7-drag').show();

                window.initS7Rotate("zoomContainer", "960,693", null);
                setTimeout(function(){
                	$('.wcs-scene7-drag').fadeOut("slow");
                }, 1300);
            }

            if ($(obj).hasClass('wcs-enlarge-view') || $(obj).hasClass('wcs-enlarge')) {
                s7enlarge_container.show();
                s7spin_container.hide();

                $('.wcs-scene7-toggle span').removeClass('wcs-color0');
                $('.wcs-scene7-toggle span.wcs-enlarge').addClass('wcs-color0');
                $('.wcs-scene7-drag').hide();

                if ($(s7enlarge_container).length) {
                    s7enlarge_container.remove();
                }

                var selected = $('#' + $(obj).data('selected'));
                //$(selected).data('current')
                window.initS7Enlarge(zoomArr.toString(), 0);
            }
        };
        /* Scene7 code ends */

        $(document.body).off('click', '.wcs-modal-box');
        $(".wcs-modal-box").on('click', function(evt){

        	 var getDataAttr = $(this).attr("data-attr");

             if(getDataAttr === 'wcs-find-giftCard') {
                tealium_data2track.push({
                    id: 'Click',
                    Click_FocusElement: $(this),
                    Tracking_Type: 'hiddenaction',
                    data_element_id: 'X_X_GiftCard_NumberPin',
                    data_description: 'Find',
                });
             }

        	var showPopUp = true;
        	if(getDataAttr == 'wcs_gw_intro_popup') {
        		var cookieValue = getCookie("GiftWrapPCPPopUpShown");
        		if(cookieValue) {
        			showPopUp = false;
        		} else {
        			document.cookie = "GiftWrapPCPPopUpShown" + "=" + true + ";path=/;";
        		}
        	} else {
        		showPopUp = true;
        	}
	        if(showPopUp) {
	            /* Enabling print.css */
	            if ($('#wcs_print_order_css').length) {
	                cssPrint = $('link[rel=stylesheet][title=print]');
	                cssPrint.removeAttr('disabled');
	            }


	            /*scene 7 overlay fix for loader*/
	            if (getDataAttr == "wcs_enlarge_rotate") {
	                var selected = $('#' + $(this).data('selected'));
	                if ($(this).hasClass('wcs-360-degree')) {
	                    selected = $('#' + $('a.wcs-enlarge-view').data('selected'));
	                }
	                //if (!$(selected).data('zoomarr')) return false;
	                if(!zoomArr.length) return false;
	            }

	            this.init = function() {
	                sliderRightMenu();
	                sliderSearch();
	                return this; /*this refere to MODULE.subModule*/
	            };
	            //open_scene7_overlay($(this));
	            /* Getting AddressID from MyDetails*/
	            if ($("#wcs-myDetails").val() == "My Details") {
	                var getHiddenVal = $(this).next().val();
	                var getIndexI = ($(this).next()).next().val();
	                var storeId = $("#storeId").val();
	                var catalogId = $("#catalogId").val();
	                var langId = $("#langId").val();

	                $("#addressId").val(getHiddenVal);
	                var params = {};
	                params.addressId = getHiddenVal;
	                params.indexI = getIndexI;
	                params.catalogId = catalogId;
	                params.storeId = storeId;
	                params.langId = langId;

	                if (getIndexI !== undefined && getIndexI !== '') {
	                    $.ajax({
	                        type: "POST",
	                        async: false,
	                        url: "EditHomeAddressView",
	                        data: params,
	                        success: function(data) {
	                            $("#wcs_myDetails_editHomeAddress").html(data);
                                $("#wcs_myDetails_editHomeAddress #delivery_information_form").click(function () {
                                    tealium_data2track.push({
                                        id: 'Click',
                                        Tracking_Type: 'hiddenaction',
                                        Click_FocusElement: this,
                                        data_element_id: 'X_Account-MyDetails_PopUpAddress_Save',
                                    });
                                });
	                            //setTimeout(function() {
	                            if($('#langId').val() != "-50"){
	                                $('.wcs-fadeout-full').height($(document).height());
	                            }else{
	                            	$('.wcs-fadeout-full').height($(document).height()+100);
	                            }
	                            //}, 800);
	                            close_lightbox();
	                            cancel_link();
	                            dropscrollerFn();
	                            select_dropbox_value();
	                            expand_dropbox();
	                            collapse_dropbox();
	                            key_nav_dropdown();



	                            validateForms($("#delivery_information_form"));
								if($('#langId').val()==-50){
	                            validateMXForm();
								}
	                            validateEmail();

	                            if($('#country').val()!==undefined){
									if($('#country').val()=="CN"){
										EditChinaAddressForm();
									}
								}
                        		}
	                    });
	                }
	            }
				var getOrderId,getOrderAmount;
	            if ($(".wcs-mySelections-hidden").val() == "My Selections") {

	                /* Function to populate the overlay for compare product */
	                if ($(this).parent().is('.wcs-button-black')) {
	                    compareProducts(getDataAttr);
	                }
	                /* Function to populate the overlay for compare product */

	            } else if ($(".wcs-myOrders-hidden").val() == "My Orders") {

	                /* Function to get order id to submit form */
	                getOrderId = $(this).attr('data-order');
	                getOrderAmount = $(this).attr('data-amount');
	                $('#' + getDataAttr).attr('data-order-lighBox', getOrderId);
	                $('#' + getDataAttr).attr('data-amout-lighBox', getOrderAmount);
	                /* Function to get order id to submit form */

	                /* Function to populate the overlay for print preview of order */
	                if ($(this).parent().is('.wcs-omega')) {
	                	printPreview(getDataAttr, getOrderId);
	                }
	                getBoletoUrl = $(this).attr('data-boleto-url');
	                if ($(this).parent().is('.wcs-omega-boleto')) {
	                	getBoletoUrl = $(this).attr('data-boleto-url');
	                	printPreviewBoleto(getDataAttr, getOrderId);
	                }



	                setTimeout(function() {
                        $('.wcs-fadeout-full').height($(document).height());
                        chooseIconClass();
	                }, 800);
	                /* End of function to populate the overlay for print preview of order */
	            } else if ($("#wcs-orderConfirmation-hidden").val() == "Order Confirmation") {

	                /* Function to get order id to submit form */
	                 getOrderId = $(this).attr('data-order');
	                $('#' + getDataAttr).attr('data-order-lighBox', getOrderId);
	                /* Function to get order id to submit form */

	                /* Function to populate the overlay for print preview of order */
	                if ($(this).attr('id') == 'printLink') {
	                    printPreview(getDataAttr, getOrderId);
	                }
	                getBoletoUrl = $(this).attr('data-boleto-url');

	                if ($(this).attr('id') == 'printBoleto') {
	                	getBoletoUrl = $(this).attr('data-boleto-url');
	                    printPreviewBoleto(getDataAttr, getOrderId);
	                }

	                setTimeout(function() {
                        $('.wcs-fadeout-full').height($(document).height());
                        chooseIconClass();
	                }, 800);
	                /* End of function to populate the overlay for print preview of order */
	            } else if ($(".wcs-trackOrders-hidden").val() == "Track Orders") {
	                getOrderId = $(this).attr('data-order');
	                getOrderAmount = $(this).attr('data-amount');
	                $('#' + getDataAttr).attr('data-order-lighBox', getOrderId);
	                $('#' + getDataAttr).attr('data-amout-lighBox', getOrderAmount);
	                setTimeout(function() {
                        $('.wcs-fadeout-full').height($(document).height());
                        chooseIconClass();
	                }, 800);
	            }

	            if ($(".wcs-mySelections-hidden").val() != "My Selections") {
                         display_Modal_1(getDataAttr);
	            }

	          //gift wrap changes -desktop
	            var giftwrapEnabled = $("#isgiftwrapItemEnabledDesktop").val();
	    	    if(giftwrapEnabled && giftwrapEnabled!=="" && giftwrapEnabled == "true") {
	            var isExpressgiftwrapEnabled = $("#isExpressgiftwrapEnabled").val();
	            if(getDataAttr == 'wcs_gw_personalmsg_pcp' && isExpressgiftwrapEnabled && isExpressgiftwrapEnabled!=="" && isExpressgiftwrapEnabled == "true") {
	            	var $giftText = $("#wcs-personalmessage-textarea");
	            	$giftText.val("");
	            	$("#noOfCharLeft").text($giftText.attr("maxlength"));

	        		var clickedEl = evt.currentTarget;
	        		var id = $(clickedEl).attr("id");
	        		var tempArr = id.split("_");
	        		$("#index").val(tempArr[1]);

	        		if(id.indexOf("edit") != -1) {
        				var modifedMsg = $("#giftMessage_"+ tempArr[1]).val();
        				$giftText.val(modifedMsg);
	        		}
	        		$giftText.trigger("keyup");

	            }
	    	    }
	            if (getDataAttr == 'wcs_s7_video') {
	                var videoViewer = new s7viewers.VideoViewer();
	                var asset = $(this).data("asset");
	                videoViewer.setContainerId("wcs_s7_video_box");
	                videoViewer.setParam("serverurl", "//images.ray-ban.com/is/image/");
	                videoViewer.setParam("contenturl", "//assets.ray-ban.com/skins/");
	                videoViewer.setParam("videoserverurl", "//assets.ray-ban.com/is/content/");
	                videoViewer.setParam("asset", asset);
	                videoViewer.setParam("config", "Scene7SharedAssets/Universal_HTML5_Video");
	                videoViewer.setParam("emailurl", "//assets.ray-ban.com/s7/emailFriend");
	                videoViewer.setParam("stagesize", "920,518");
	                videoViewer.init();
	                evt.preventDefault();
	            }

	            if(getDataAttr == "wcs_gw_preview_container") {
	            	var gwMessage = $(this).parents(".wcs-gw-exapandable-item").find(".wcs-gw-exapandable-item-msg").val();
	            	$(this).parents(".wcs-gw-exapandable").find(".wcs_gw_preview_data").find("#giftMessageText").html(gwMessage);
	            	$("#"+getDataAttr).find("#wcs_gw_preview_content").html($(this).parents(".wcs-gw-exapandable").find(".wcs_gw_preview_data").html());
	            }
	       }
        });
    };
    show_light_box();
    window.display_Modal_1 = function(getDataAttr) {
        const docht = $(document).height();
        $('.wcs-fadeout-full').removeClass('wcs-hide').css({
            'height': docht + 'px'
        });

        $('#' + getDataAttr).show();
        display_center_1($('#' + getDataAttr));
        if (window.isROX == 'true' || ($('#isRoxEnabled').length>0 && $('#isRoxEnabled').val() === 'true')) {
            $('#D_QuickView_Prod').css('display', 'none');
        } else {
            $('#D_QuickView').css('display', 'none');
        }

        $('#wcs-compare-view .wcs-addtobag').off('click').on('click',function(){
            sessionStorage.removeItem('rayban.' + $('#storeId').val() + '.' + $('#langId').val() + '.sidebar_refreshLS');
            sessionStorage.removeItem('rayban.' + $('#storeId').val() + '.' + $('#langId').val() +'.headerprofile_refreshLS');
        });

        if ( getDataAttr === 'wcs_myDetails_editHomeAddress') {
            $('#wcs_myDetails_editHomeAddress').find('input').on('focusout', function() {
                if ($(this).hasClass('ui-state-valid')) {
                    $(this).closest('.rb-fieldrow').addClass('rb-validrow');
                }
                const $target = $(this);
                const $changedInput = $target.closest('.jp-phone-container');

                const currentId = $target.attr('id');
                const part1 = $changedInput.find('#part-1');
                const part2 = $changedInput.find('#part-2');
                const part3 = $changedInput.find('#part-3');
                const regExp = (/^\d{1,6}$/);

                const part1Valid = currentId === 'part-1' || !part1.hasClass('rb-input-element-invalid');
                const part2Valid = currentId === 'part-2' || !part2.hasClass('rb-input-element-invalid');
                const part3Valid = currentId === 'part-3' || !part3.hasClass('rb-input-element-invalid');
                const isPhonePartsValid = part1Valid && part2Valid && part3Valid;

                if (regExp.test($target.val()) && isPhonePartsValid) {
                  $changedInput.removeClass('phone-invalid');
                } else {
                  $changedInput.addClass('phone-invalid');
                }
            });
        };
    };

    function chooseIconClass(){
        console.log('Chosing icon class...');

        if ($('#storeTypeIcon').val() != undefined) {
            var storeTypeIcon = $('#storeTypeIcon').val().toLowerCase();
            var storeType = 'other';

            switch(storeTypeIcon) {
                case 'sgh':
                    storeType = 'sgh-ico';
                    break;
                case 'ray-ban':
                    storeType = 'rayban-ico';
                    break;
                case 'lenscrafters':
                    storeType = 'lc-ico';
                    break;
                case 'salmoiraghi & vigano':
                    storeType = 'sv-ico';
                    break;
                default:
                    storeType = 'other'
                    break;
            }

            if (storeType === 'other') {
                $('#icoOrder').removeClass().addClass('ups-ico-mapmodal-viewmap');
                $('#icoOrderDetails').removeClass().addClass('ico');
                $('#icoOrderDetailsPrint').removeClass().addClass('ico');
                $('#titleOrder').removeClass().addClass('tit viewmap-overlay');
            } else {
                $('#icoOrder').removeClass().addClass(storeType);
                $('#icoOrderDetails').removeClass().addClass(storeType);
                $('#icoOrderDetailsPrint').removeClass().addClass(storeType);
                $('#titleOrder').removeClass('viewmap-overlay');
            }
        }
    }

    function printPreview(getDataTextAttr, getOrderId) {
        var URL = "PrintPreviewOrderView";
        var newparams = {};
        newparams.orderId = getOrderId;
        if( $('#storeId').length > 0) {
        	newparams.storeId = $('#storeId').val();
        }
        if ($("#wcs-orderConfirmation-hidden").val() == "Order Confirmation") {
            newparams.isOrderConfirmation = "true";
        }

        newparams.email1=$("#shippingEmail").text();
        newparams.errorView="TrackOrdersView";
        newparams.catalogId=$("#catalogId").val();
        newparams.langId=$("#langId").val();
        newparams.URL="PrintOrderView";

        $('#wcs_print_preview_' + getOrderId).addClass('wcs-hide');
        $.ajax({
            type: 'POST',
            url: URL,
            data: newparams,
            success: function(result, status, xhr) {
                $('#wcs_print_preview_' + getOrderId).removeClass('wcs-hide');
        		if(xhr.responseText.indexOf('wcs-pp-header')==-1){
        			window.location.href = $('#wcs-print-logon-url').val();
        			return;
        		}
                prevOrderId = $("#printPrevOrderId").val();
                if (prevOrderId === "") {
                    $("#printPrevOrderId").val(getOrderId);
                    $("#wcs_print_preview").attr("id", "wcs_print_preview_" + getOrderId);
                } else {
                    $("#wcs_print_preview_" + prevOrderId).attr("id", "wcs_print_preview_" + getOrderId);
                    $("#printPrevOrderId").val(getOrderId);
                }
                $("#wcs_print_preview_" + getOrderId).html(result);
                chooseIconClass();
                display_Modal_1(getDataTextAttr);
               /** commented for RB-11840
                // Initializing scrollbar for registered user print preview lightbox
                if (!$('html').is('.ie8')) {
                    var mySliderScroll = new iScroll('wcs_print_order_' + getOrderId, {
                        hScrollbar: false,
                        vScrollbar: true,
                        draggableScrollbars: true
                    });
                }
                */
                close_lightbox();
                $('#wcs-tc-close-pp-' + getOrderId).click(function() {
                	 getAttr = $(this).parent().parent().attr('data-order-lighbox');
                     $(this).parents('.wcs-print-preview-wrapper').children('span.wcs-close-btn').trigger('click');
                });
                setTimeout(function() {
                    $('.wcs-fadeout-full').height($(document).height());
                }, 800);
                custom_scrollable_hover();
            },
            error: function(xhr, ajaxOptions, thrownError) {
            	window.location.href = $('#wcs-print-logon-url').val();
            }
        });
    }



    function printPreviewBoleto(getDataTextAttr, getOrderId) {
        var URL = "PrintPreviewBoletoView";
        var newparams = {};
        newparams.orderId = getOrderId;
        newparams.boletoUrl = getBoletoUrl;

        $('#wcs_print_preview_' + getOrderId).addClass('wcs-hide');
        $.ajax({
            type: 'POST',
            url: URL,
            data: newparams,
            success: function(result, status, xhr) {
            $('#wcs_print_preview_' + getOrderId).removeClass('wcs-hide');
                prevOrderId = $("#printPrevOrderId").val();
                if (prevOrderId === "") {
                    $("#printPrevOrderId").val(getOrderId);
                    $("#wcs_print_preview").attr("id", "wcs_print_preview_" + getOrderId);
                } else {
                    $("#wcs_print_preview_" + prevOrderId).attr("id", "wcs_print_preview_" + getOrderId);
                    $("#printPrevOrderId").val(getOrderId);
                }
                $("#wcs_print_preview_" + getOrderId).html(result);
                chooseIconClass();
                display_Modal_1(getDataTextAttr);
               /** commented for RB-11840
                // Initializing scrollbar for registered user print preview lightbox
                if (!$('html').is('.ie8')) {
                    var mySliderScroll = new iScroll('wcs_print_order_' + getOrderId, {
                        hScrollbar: false,
                        vScrollbar: true,
                        draggableScrollbars: true
                    });
                }
                */
                close_lightbox();
                $('#wcs-tc-close-pp-' + getOrderId).click(function() {
                    getAttr = $(this).parent().parent().attr('data-order-lighbox');
                    $(this).parents('.wcs-print-preview-wrapper').children('span.wcs-close-btn').trigger('click');
                });
                setTimeout(function() {
                    $('.wcs-fadeout-full').height($(document).height());
                }, 800);
                custom_scrollable_hover();
            },
            error: function(xhr, ajaxOptions, thrownError) {
            	window.location.href = $('#wcs-print-logon-url').val();
            }
        });
    }
    $('#wcs-tc-close').click(function() {
        $('.wcs-close-btn').trigger('click');
    });
    $(".wcs-delivery-valid").each(function() {
        if ($(this).val() !== '') {
            $(this).trigger("blur");
        }
    });

    function generateCompareCookie() {
        var compare_id_1 = $('.compare-1').next().attr("catalogentryid"),
            compare_id_2 = $('.compare-2').next().attr("catalogentryid"),
           	removeFromList1 = $('.compare-1').attr("removeFromList"),
          	 removeFromList2 = $('.compare-2').attr("removeFromList"),
         	configurationId1 = $('.compare-1').attr("configurationId"),
         	configurationId2 = $('.compare-2').attr("configurationId"),
         	roxSet1 = $('.compare-1').attr("roxSet"),
         roxSet2 = $('.compare-2').attr("roxSet");
        roxSet1 = roxSet1.replace(/_/g, '$');
        roxSet2 = roxSet2.replace(/_/g, '$');
        if(configurationId1 === "") {
        	configurationId1 = "empty";
        }
        if(configurationId2 === "") {
        	configurationId2 = "empty";
        }
        setCookie("comparePros", compare_id_1 + "/" + removeFromList1 + "/" + configurationId1  + "/" + roxSet1 + "_" + compare_id_2 + "/" + removeFromList2 + "/" + configurationId2  + "/" + roxSet2, 365);
    }
    //Function added for analytics to get the Skuid for product compare

    function generateCompareProdSkuId() {
        var userType = $("#userType").val();
        var country = $("#county").val();
        var sku_id_1 = $('.compare-1').next().attr("skuId");
        var sku_id_2 = $('.compare-2').next().attr("skuId");
        var sku = sku_id_1 + ',' + sku_id_2;


    }

    function setCookie(c_name, value, exdays) {
        var exdate = new Date();
        exdate.setDate(exdate.getDate() + exdays);
        var c_value = escape(value);
        document.cookie = c_name + "=" + c_value;
    }

    function getIds(idType, controllerURL) {
        var myId = "";
        if (controllerURL) {
            var temp = controllerURL;
            var tokens;
            if (temp.indexOf(idType) != -1) {
                temp = temp.substring(temp.indexOf(idType));
                tokens = temp.split("&");
                var tokens2 = tokens[0].split("=");
                myId = tokens2[1];
            }
            if (myId.indexOf("#") != -1) {
                tokens = myId.split("#");
                myId = tokens[0];
            }
        }
        return myId;
    }

    function AddClassForCompareProducts() {
        if ($('#frmMat_1').attr('rel') == $('#frmMat_2').attr('rel')) {
            $('#frmMat_1').addClass("font-helvetica font-12 wcs-lightgrey");
            $('#frmMat_2').addClass("font-helvetica font-12 wcs-lightgrey");
            $('#frmMat_title_1').addClass("wcs-lightgrey");
            $('#frmMat_title_2').addClass("wcs-lightgrey");
        } else {
            $('#frmMat_1').addClass("font-helvetica font-12");
            $('#frmMat_2').addClass("font-helvetica font-12");
            $('#frmMat_title_1').removeClass("wcs-lightgrey");
            $('#frmMat_title_2').removeClass("wcs-lightgrey");
        }
        if ($('#frmClr_1').attr('rel') == $('#frmClr_2').attr('rel')) {
            $('#frmClr_1').addClass("font-helvetica font-12 wcs-lightgrey");
            $('#frmClr_2').addClass("font-helvetica font-12 wcs-lightgrey");
            $('#frmClr_title_1').addClass("wcs-lightgrey");
            $('#frmClr_title_2').addClass("wcs-lightgrey");
        } else {
            $('#frmClr_1').addClass("font-helvetica font-12");
            $('#frmClr_2').addClass("font-helvetica font-12");
            $('#frmClr_title_1').removeClass("wcs-lightgrey");
            $('#frmClr_title_2').removeClass("wcs-lightgrey");
        }
        if ($('#TmpClr_1').attr('rel') == $('#TmpClr_2').attr('rel')) {
            $('#TmpClr_1').addClass("font-helvetica font-12 wcs-lightgrey");
            $('#TmpClr_2').addClass("font-helvetica font-12 wcs-lightgrey");
            $('#TmpClr_title_1').addClass("wcs-lightgrey");
            $('#TmpClr_title_2').addClass("wcs-lightgrey");
        } else {
            $('#TmpClr_1').addClass("font-helvetica font-12");
            $('#TmpClr_2').addClass("font-helvetica font-12");
            $('#TmpClr_title_1').removeClass("wcs-lightgrey");
            $('#TmpClr_title_2').removeClass("wcs-lightgrey");
        }
        if ($('#TmpTipClr_1').attr('rel') == $('#TmpTipClr_2').attr('rel')) {
            $('#TmpTipClr_1').addClass("font-helvetica font-12 wcs-lightgrey");
            $('#TmpTipClr_2').addClass("font-helvetica font-12 wcs-lightgrey");
            $('#TmpTipClr_title_1').addClass("wcs-lightgrey");
            $('#TmpTipClr_title_2').addClass("wcs-lightgrey");
        } else {
            $('#TmpTipClr_1').addClass("font-helvetica font-12");
            $('#TmpTipClr_2').addClass("font-helvetica font-12");
            $('#TmpTipClr_title_1').removeClass("wcs-lightgrey");
            $('#TmpTipClr_title_2').removeClass("wcs-lightgrey");
        }

        if ($('#TmpClr_title_1').html() != $('#TmpClr_title_2').html()) {
            $('#TmpClr_title_2').html($('#TmpClr_title_1').html());
        }
        if ($('#TmpTipClr_title_1').html() != $('#TmpTipClr_title_2').html()) {
            $('#TmpTipClr_title_2').html($('#TmpTipClr_title_1').html());
        }

        if ($('#Size_1').attr('rel') == $('#Size_2').attr('rel')) {
            $('#Size_1').addClass("font-helvetica font-12 wcs-lightgrey");
            $('#Size_2').addClass("font-helvetica font-12 wcs-lightgrey");
            $('#Size_title_1').addClass("wcs-lightgrey");
            $('#Size_title_2').addClass("wcs-lightgrey");
        } else {
            $('#Size_1').addClass("font-helvetica font-12");
            $('#Size_2').addClass("font-helvetica font-12");
            $('#Size_title_1').removeClass("wcs-lightgrey");
            $('#Size_title_2').removeClass("wcs-lightgrey");
        }

        if ($('#EngravingLeft_1').length > 0) {
            if ($('#EngravingLeft_1').attr('rel') == $('#EngravingLeft_2').attr('rel')) {
                $('#EngravingLeft_1').addClass("font-helvetica font-12 wcs-lightgrey");
                $('#EngravingLeft_2').addClass("font-helvetica font-12 wcs-lightgrey");
                $('#EngravingLeft_title_1').addClass("wcs-lightgrey");
                $('#EngravingLeft_title_2').addClass("wcs-lightgrey");
            } else {
                $('#EngravingLeft_1').addClass("font-helvetica font-12");
                $('#EngravingLeft_2').addClass("font-helvetica font-12");
                $('#EngravingLeft_title_1').removeClass("wcs-lightgrey");
                $('#EngravingLeft_title_2').removeClass("wcs-lightgrey");
            }
        }

        if ($('#EngravingRight_1').length > 0) {
            if ($('#EngravingRight_1').attr('rel') == $('#EngravingRight_2').attr('rel')) {
                $('#EngravingRight_1').addClass("font-helvetica font-12 wcs-lightgrey");
                $('#EngravingRight_2').addClass("font-helvetica font-12 wcs-lightgrey");
                $('#EngravingRight_title_1').addClass("wcs-lightgrey");
                $('#EngravingRight_title_2').addClass("wcs-lightgrey");
            } else {
                $('#EngravingRight_1').addClass("font-helvetica font-12");
                $('#EngravingRight_2').addClass("font-helvetica font-12");
                $('#EngravingRight_title_1').removeClass("wcs-lightgrey");
                $('#EngravingRight_title_2').removeClass("wcs-lightgrey");
            }
        }

        if ($('#lnsTrt_1').attr('rel') == $('#lnsTrt_2').attr('rel')) {
            $('#lnsTrt_1').addClass("font-helvetica font-12 wcs-lightgrey");
            $('#lnsTrt_2').addClass("font-helvetica font-12 wcs-lightgrey");
            $('#lnsTrt_title_1').addClass("wcs-lightgrey");
            $('#lnsTrt_title_2').addClass("wcs-lightgrey");
        } else {
            $('#lnsTrt_1').addClass("font-helvetica font-12");
            $('#lnsTrt_2').addClass("font-helvetica font-12");
            $('#lnsTrt_title_1').removeClass("wcs-lightgrey");
            $('#lnsTrt_title_2').removeClass("wcs-lightgrey");
        }
        if ($('#lnsTch_1').attr('rel') == $('#lnsTch_2').attr('rel')) {
            $('#lnsTch_1').addClass("font-helvetica font-12 wcs-lightgrey");
            $('#lnsTch_2').addClass("font-helvetica font-12 wcs-lightgrey");
            $('#lnsTch_title_1').addClass("wcs-lightgrey");
            $('#lnsTch_title_2').addClass("wcs-lightgrey");
        } else {
            $('#lnsTch_1').addClass("font-helvetica font-12");
            $('#lnsTch_2').addClass("font-helvetica font-12");
            $('#lnsTch_title_1').removeClass("wcs-lightgrey");
            $('#lnsTch_title_2').removeClass("wcs-lightgrey");
        }

        if ($('#CaseColor_1').length > 0) {
            if ($('#CaseColor_1').attr('rel') == $('#CaseColor_2').attr('rel')) {
                $('#CaseColor_1').addClass("font-helvetica font-12 wcs-lightgrey");
                $('#CaseColor_2').addClass("font-helvetica font-12 wcs-lightgrey");
                $('#CaseColor_title_1').addClass("wcs-lightgrey");
                $('#CaseColor_title_2').addClass("wcs-lightgrey");
            } else {
                $('#CaseColor_1').addClass("font-helvetica font-12");
                $('#CaseColor_2').addClass("font-helvetica font-12");
                $('#CaseColor_title_1').removeClass("wcs-lightgrey");
                $('#CaseColor_title_2').removeClass("wcs-lightgrey");
            }
        }

        if ($('#CaseEngraving_1').length > 0) {
            if ($('#CaseEngraving_1').attr('rel') == $('#CaseEngraving_2').attr('rel')) {
                $('#CaseEngraving_1').addClass("font-helvetica font-12 wcs-lightgrey");
                $('#CaseEngraving_2').addClass("font-helvetica font-12 wcs-lightgrey");
                $('#CaseEngraving_title_1').addClass("wcs-lightgrey");
                $('#CaseEngraving_title_2').addClass("wcs-lightgrey");
            } else {
                $('#CaseEngraving_1').addClass("font-helvetica font-12");
                $('#CaseEngraving_2').addClass("font-helvetica font-12");
                $('#CaseEngraving_title_1').removeClass("wcs-lightgrey");
                $('#CaseEngraving_title_2').removeClass("wcs-lightgrey");
            }
        }

        if ($('#CaseSize_1').length > 0) {
            if ($('#CaseSize_1').attr('rel') == $('#CaseSize_2').attr('rel')) {
                $('#CaseSize_1').addClass("font-helvetica font-12 wcs-lightgrey");
                $('#CaseSize_2').addClass("font-helvetica font-12 wcs-lightgrey");
                $('#CaseSize_title_1').addClass("wcs-lightgrey");
                $('#CaseSize_title_2').addClass("wcs-lightgrey");
            } else {
                $('#CaseSize_1').addClass("font-helvetica font-12");
                $('#CaseSize_2').addClass("font-helvetica font-12");
                $('#CaseSize_title_1').removeClass("wcs-lightgrey");
                $('#CaseSize_title_2').removeClass("wcs-lightgrey");
            }
        }

    }

    function compareProducts(getDataTextAttr) {
        generateCompareCookie();
        var storeId = $('#compareStoreId').val();
        var catalogId = $('#compareCatalogId').val();
        var newparams = {};
        newparams.storeId = storeId;
        newparams.catalogId = catalogId;
        $.ajax({
            type: 'POST',
            url: "CompareProView",
            data: newparams,
            success: function(result) {
                var cookieValue = getCookie("comparePros");
                var catentryList = cookieValue.split("_");
                var removeValueList = catentryList[0].split("/");
                var count = 0;
                configurationid1 = removeValueList[2];
                ++count;
                removeValueList = catentryList[1].split("/");
                configurationid2 = removeValueList[2];
                ++count;

                if (configurationid1 !== "" && configurationid2 !== "" && configurationid1 != "empty") {
                    $("#" + getDataTextAttr).addClass("wcs-remixed-compare-view");
                } else {
                    $("#" + getDataTextAttr).removeClass("wcs-remixed-compare-view");
                }

                $("#" + getDataTextAttr).html(result).promise().done(function() {
                    // Compare overlay - RB-10032
                    if ($.trim($("#wcs-compare-view .wcs-cp-full-desc").text()) !== "") {
                        var heightOnLeft = $("#wcs-compare-view .wcs-cp-readmore-container").eq(0).height();
                        var heightOnRight = $("#wcs-compare-view .wcs-cp-readmore-container").eq(1).height();
                        var height = (heightOnLeft > heightOnRight) ? heightOnLeft : heightOnRight;
                        $("#wcs-compare-view .wcs-cp-readmore-container").css("height", height);

                        if ($("#wcs-compare-view").parent().hasClass("wcs-remixed-compare-view")) {
                            $("#wcs-compare-view .wcs-compare-products-divider").css("height", 814 + height);
                        } else {
                            $("#wcs-compare-view .wcs-compare-products-divider").css("height", 605 + height);
                        }
                    } else {
                        if ($("#wcs-compare-view").parent().hasClass("wcs-remixed-compare-view")) {
                            $("#wcs-compare-view .wcs-compare-products-divider").css("height", 814);
                        } else {
                            $("#wcs-compare-view .wcs-compare-products-divider").css("height", 605);
                        }
                    }
                });

                display_Modal_1(getDataTextAttr);
                AddClassForCompareProducts();
                close_lightbox();
                generateCompareProdSkuId();
                setTimeout(function() {
                    $('.wcs-fadeout-full').height($(document).height());
                }, 800);
                openLinksInNewTab();
            },
            error: function(xhr, ajaxOptions, thrownError) {

            }
        });
    }
    $(".wcs-addtobag2").click(function() {
        var addtobags = $("#wcs_compare_quickview").find(".wcs-addtobag");
        $.each(addtobags, function() {
            $(this).trigger("click");
        });
    });
    window.refactor = function() {
        var form_entities_myfav = $(".wcs-myfav").next().find(".form_entity").parent();
        var form_entities_myremix = $(".wcs-myremix").next().find(".form_entity").parent();
        var form_entities_mypurchase = $(".wcs-mypurchase").next().find(".form_entity").parent();
        var form_entities_recent = $(".wcs-recent").next().find(".form_entity").parent();
        $("#wcs-myfav-count").html(form_entities_myfav.length);
        $("#wcs-myremix-count").html(form_entities_myremix.length);
        $("#wcs-mypur-count").html(form_entities_mypurchase.length);
        $("#wcs-myrec-count").html(form_entities_recent.length);
        if (form_entities_myfav.length === 0) {
            deleteheaderinfo($(".wcs-myfav"));
        }
        if (form_entities_myremix.length === 0) {
            deleteheaderinfo($(".wcs-myremix"));
        }
        if (form_entities_mypurchase.length === 0) {
            deleteheaderinfo($(".wcs-mypurchase"));
        }
        if (form_entities_recent.length === 0) {
            deleteheaderinfo($(".wcs-recent"));
        }

        var grid_size = 12;
        var total = 0;

        var items = [form_entities_myfav, form_entities_myremix, form_entities_mypurchase, form_entities_recent];
        var i = 0;

        $.each(items, function() {
            var first = true;

            $.each(items[i], function() {
                if (!first) {
                    $(this).removeClass("wcs-alpha");
                }
                first = false;
            });


            $.each(items[i], function() {
                total++;
                if (total % 5 === 0 || total === 1) {
                    $(this).addClass("wcs-alpha");
                    $(this).removeClass("wcs-omega");
                } else {
                    $(this).addClass("wcs-omega");
                }
            });
            i++;
            total = 0;
        });

    };

    function deleteheaderinfo(curObject) {
        $(curObject).remove();
    }
}
$(document).ready(function(){
	hide_show_favorite_selection();
    hide_show_selection();
	//compareAndQuickView();
});


window.hide_show_favorite_selection = function() {
    if ($('#wcs-myfav-count').text() === 0) {
        $('#wcs-myfav-count').parent('h4').next('a').hide();
    } else {
        $('#wcs-myfav-count').parent('h4').next('a').show();
    }
};

window.hide_show_selection = function() {
    $('.selection-skeleton').addClass('wcs-hide');

    if ($('#emptyfav').val() == 'true' && ($('#emptyPur').val() == 'true') && $('#recViewItems').val() == '0' && $('#typeUser').val() == 'R') {
        $('#emptypage').removeClass('wcs-hide');
    } else if ($('#emptyfav').val() == 'true' && $('#recViewItems').val() == '0' && $('#typeUser').val() === undefined) {
        $('#emptypage').removeClass('wcs-hide');
    } else {
        $('#mainone').removeClass('wcs-hide');
    }

    var recentlyViewItems = Number($('#recViewItems').val());

    if(!isNaN(Number(recentlyViewItems))){
    	$("#wcs-myrec-count").text(recentlyViewItems);
    }
};
